import { Button } from 'primereact/button'
import { useEffect, useCallback, useState, useRef } from 'react'
import {
	DETAILS_APPLY_FOR,
	DIMENSION_UNIT,
	DIMENSION_UNIT_SELECT_ITEMS,
	FORM_FIELDS,
	getRoundedValue,
	LOOSE_FORM_FIELDS,
	WEIGHT_UNIT_SELECT_ITEMS,
} from '../../constants'

import { validateLooseDetails, validateLineItemWeights } from '../SearchPanel/formUtils'
import { validateTotalWeight } from '../SearchPanel/formUtils'
import { validateOperationalWeight } from '../SearchPanel/formUtils'
import './item-form.scss'
import MESSAGES from '../../constants/Messages'
import { useTranslation } from 'react-i18next'
import {
	calculateWeightFromKg,
	calculateWeightToKg,
	allowNumberOnly,
} from "../../utils/common";
import CommonInput from "../../common/Resusable/CommonInput";
import plusIcon from '../../assets/images/plusBlue.svg';
import uploadIcon from '../../assets/images/uploadIcon.svg'
import RadioToggle from '../SearchPanel/RadioToggle'
import deleteIcon from "../../assets/images/delete_icon_red.png";
import FileUpload from '../LooseLineItem/FileUpload'
import { CommonDropDown } from '../../common/Resusable/CommonDropDown'


const LooseItemForm = ({
	looseDetails,
	setLooseDetails,
	totalWeight,
	setTotalWeight,
	setLooseItemsGrossWeight,
	weightUnit,
	setWeightUnit,
	dimensionUnit,
	setDimensionUnit,
	isAllStackable,
	setAllStackable,
	isAllTiltable,
	setAllTiltable,
	handleAddLineItem,
	setTotalPieces,
	error,
	setError,
	setTotalVolumeInMeters,
	setTotalWeightInKg,
	totalWeightInKilo,
	totalVolumeinMtrs,
	setChargeableWeight,
	setChargeableWeightInSelectedUnit,
	calculatedTotalWeight,
	setCalculatedTotalWeight,
	setActualVolume,
	setActualChargeableWeight,
	setActualGrossWeight,
	actualTotalIneItemWeight,
	setActualTotalIneItemWeight,
	draftCallback,
	adjustedWeight,
	setAdjustedWeight,
	showOpWeight,
	setShowOpweight,
	isHideReprocessComponents,
	setDisableButton,
	isMultipleBookingEdit,
	isAdjustedWeightDisabled,
	onTotalWeightChange
}) => {
	const { t, i18n } = useTranslation(["labels", "errors"]);
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
	const [focusedIndex, setFocusedIndex] = useState(null);
	const [showFileUpload, setShowFileUpload] = useState(false);
	const totalWeightOnFocus = useRef(totalWeight);



	const [adjustedWeightInKg, setAdjustedWeightInKg] = useState(0)

	useEffect(() => {
		if (isAdjustedWeightDisabled && Number(adjustedWeight) > 0) {
			setChargeableWeight(Number(adjustedWeight))
			setChargeableWeightInSelectedUnit(Number(adjustedWeight))
			return
		}
		let volumetricWeight = 0
		let chargeableWeight
		let chargeableWeightInSelectedUnit
		if (totalVolumeinMtrs) {
			//volumetricWeight = round(totalVolumeinMtrs, 2) * 166.6667
			volumetricWeight = Number(totalVolumeinMtrs).toFixed(2) * 166.6667
		}

		if (totalWeightInKilo || volumetricWeight || adjustedWeightInKg) {
			if (Number(totalWeightInKilo) >= Number(volumetricWeight)) {
				if (
					adjustedWeightInKg &&
					Number(totalWeightInKilo) <= Number(adjustedWeightInKg)
				) {
					chargeableWeight = getRoundedValue(Number(adjustedWeightInKg))
					chargeableWeightInSelectedUnit = adjustedWeight
				} else {
					chargeableWeight = Number(totalWeightInKilo)

					if (totalWeight) {
						chargeableWeightInSelectedUnit = totalWeight
					} else {
						chargeableWeightInSelectedUnit = actualTotalIneItemWeight
					}
				}
			} else {
				if (
					adjustedWeightInKg &&
					Number(totalWeightInKilo) <= Number(adjustedWeightInKg) &&
					Number(volumetricWeight) <= Number(adjustedWeightInKg)
				) {
					chargeableWeight = getRoundedValue(Number(adjustedWeightInKg))
					chargeableWeightInSelectedUnit = adjustedWeight
				} else {
					chargeableWeight = getRoundedValue(Number(volumetricWeight))
					chargeableWeightInSelectedUnit = calculateWeightFromKg(
						chargeableWeight,
						weightUnit
					)
				}
			}
			setChargeableWeight(chargeableWeight)
			setChargeableWeightInSelectedUnit(chargeableWeightInSelectedUnit)
		}
	}, [totalVolumeinMtrs, totalWeightInKilo, totalWeight, adjustedWeightInKg, adjustedWeight, weightUnit, isAdjustedWeightDisabled])



	useEffect(() => {
		handleSummaryChange(looseDetails)
		handleWeightInput(looseDetails)
	}, [looseDetails, weightUnit, dimensionUnit, totalWeight])

	useEffect(() => {
		if (totalWeight) {
			setActualGrossWeight(totalWeight)
			const totalWeightinKg = calculateWeightToKg(totalWeight, weightUnit)
			setTotalWeightInKg(totalWeightinKg)
		} else {
			setActualGrossWeight(calculatedTotalWeight)
			const calculatedTotalWeightInKg = calculateWeightToKg(
				calculatedTotalWeight,
				weightUnit
			)
			setLooseItemsGrossWeight(calculatedTotalWeightInKg)
			setTotalWeightInKg(calculatedTotalWeightInKg)
		}
		if (adjustedWeight) {
			const operationalWeightInKg = calculateWeightToKg(
				adjustedWeight,
				weightUnit
			)
			setAdjustedWeightInKg(operationalWeightInKg)
		} else {
			setAdjustedWeightInKg(0)
		}
	}, [totalWeight, calculatedTotalWeight, weightUnit, adjustedWeight])

	const handleItemChange = (key, value, index) => {
		const templooseDetails = JSON.parse(JSON.stringify(looseDetails))
		if (key == 'stackable' || key == 'turnable') {
			templooseDetails[index][key] = !value
		} else {

			if (
				key == 'length' ||
				key == 'width' ||
				key == 'height'
			) {
				if (value.length <= 5) {
					templooseDetails[index][key] = value ? Number(value) : value
				}
			} else if (key == 'weight') {
				if (value.length <= 9) {
					templooseDetails[index][key] = value ? Number(value) : value
				}
			} else if (key === "pieces") {
				if (value.length <= 4) {
					templooseDetails[index][key] = value
				}
			}
			else {
				templooseDetails[index][key] = value
			}
			draftCallback(true)
		}
		setLooseDetails([...templooseDetails])

		if (key == 'weightType') {
			handleWeightInput(templooseDetails)
		}
	}

	const handleWeightInput = (LooseDetails) => {
		const calculatedTotalWeight = [...LooseDetails, {}].reduce((curr, next) => {
			return {
				weight:
					(curr.weightType === DETAILS_APPLY_FOR.PER_ITEM
						? (curr.pieces ? curr.pieces * 1 : 0) *
						(curr.weight ? curr.weight * 1 : 0)
						: curr.weight
							? curr.weight * 1
							: 0) +
					(next.weightType === DETAILS_APPLY_FOR.PER_ITEM
						? (next.pieces ? next.pieces * 1 : 0) *
						(next.weight ? next.weight * 1 : 0)
						: next.weight
							? next.weight * 1
							: 0),
				pieces: 1,
			}
		}).weight
		setCalculatedTotalWeight(calculatedTotalWeight)
		setActualTotalIneItemWeight(calculatedTotalWeight)
	}

	const handleLineItemWeightRemoval = () => {
		let looseDetailsErrors =
			error && error[FORM_FIELDS.LOOSE_ITEMS]
				? error[FORM_FIELDS.LOOSE_ITEMS]
				: []
		looseDetailsErrors = validateLineItemWeights(
			looseDetails,
			looseDetailsErrors
		)
		setError({ ...error, [FORM_FIELDS.LOOSE_ITEMS]: looseDetailsErrors })
	}

	const handleSummaryChange = (LooseDetails) => {
		let quantity = 0
		let totalVolumeinMeters = 0
		let actualVolumeInSelectedUnit = 0
		LooseDetails?.forEach(function (element) {
			if (element.pieces) {
				quantity += element.pieces * 1
			}
			if (element.pieces && element.length && element.width && element.height) {
				actualVolumeInSelectedUnit +=
					parseFloat(element.width * element.length * element.height) *
					parseInt(element.pieces)
			}
			if (element.pieces && element.length && element.width && element.height) {
				if (dimensionUnit == DIMENSION_UNIT.INCHES) {
					totalVolumeinMeters +=
						parseFloat(
							element.width *
							0.0254 *
							(element.length * 0.0254) *
							(element.height * 0.0254)
						) * parseInt(element.pieces)
				}
				if (dimensionUnit == DIMENSION_UNIT.CENTIMETERS) {
					totalVolumeinMeters +=
						parseFloat(
							element.width *
							0.01 *
							(element.length * 0.01) *
							(element.height * 0.01)
						) * parseInt(element.pieces)
				}
			}
		})
		if (totalVolumeinMeters && totalVolumeinMeters < 0.01) {
			totalVolumeinMeters = 0.01
		}
		if (actualVolumeInSelectedUnit && actualVolumeInSelectedUnit < 0.01) {
			actualVolumeInSelectedUnit = 0.01
		}
		setActualVolume(actualVolumeInSelectedUnit)
		setTotalVolumeInMeters(totalVolumeinMeters)
		setTotalPieces(quantity)
	}
	const handleRemoveItem = (index) => {
		const looseDetailsTemp = looseDetails.filter((itemDetail, curr) => {
			return index !== curr
		})
		setLooseDetails(looseDetailsTemp)
		handleWeightInput(looseDetailsTemp)

		let looseDetailsErrors = validateLooseDetails(looseDetailsTemp)
		const hasError = looseDetailsErrors.some((item) => (item ? true : false))
		error[FORM_FIELDS.LOOSE_ITEMS] = hasError ? looseDetailsErrors : null
	}

	const clearError = (key) => {
		const tempError = error ? { ...error } : null
		if (tempError) {
			tempError[key] = null
			setError(tempError)
		}
	}
	const handleOpWeightErr = (key) => {
		const tempError = error ? { ...error } : null
		if (tempError) {
			tempError[key] = validateOperationalWeight(totalWeight, adjustedWeight)
			setError(tempError)
		}
	}
	const clearItemError = (key, index) => {
		const tempError = error ? { ...error } : null
		if (
			tempError &&
			tempError[FORM_FIELDS.LOOSE_ITEMS] &&
			tempError[FORM_FIELDS.LOOSE_ITEMS][index]
		) {
			tempError[FORM_FIELDS.LOOSE_ITEMS][index][key] = null
			setError(tempError)
		}
	}

	const handleClickAdd = (e) => {
		handleAddLineItem(e)
	}
	const isNum = (val) => /^\d+$/.test(val)

	const validateLineItemOnBlur = (type, key) => {
		let looseDetailsErrors =
			error && error[FORM_FIELDS.LOOSE_ITEMS]
				? error[FORM_FIELDS.LOOSE_ITEMS]
				: []
		if (type == 'pieces') {
			const errorMsg =
				looseDetails[key].pieces && isNum(looseDetails[key].pieces)
					? null
					: MESSAGES.INVALID_PIECES
			if (errorMsg) {
				looseDetailsErrors[key] = looseDetailsErrors[key]
					? { ...looseDetailsErrors[key], [LOOSE_FORM_FIELDS.PIECES]: errorMsg }
					: { [LOOSE_FORM_FIELDS.PIECES]: errorMsg }
			}
			setError({ ...error, [FORM_FIELDS.LOOSE_ITEMS]: looseDetailsErrors })
		}
		if (type == 'width') {
			const errorMsg =
				looseDetails[key].width && isNum(looseDetails[key].width)
					? null
					: MESSAGES.INVALID_WIDTH
			if (errorMsg) {
				looseDetailsErrors[key] = looseDetailsErrors[key]
					? { ...looseDetailsErrors[key], [LOOSE_FORM_FIELDS.WIDTH]: errorMsg }
					: { [LOOSE_FORM_FIELDS.WIDTH]: errorMsg }
			}
			setError({ ...error, [FORM_FIELDS.LOOSE_ITEMS]: looseDetailsErrors })
		}
		if (type == 'height') {
			const errorMsg =
				looseDetails[key].height && isNum(looseDetails[key].height)
					? null
					: MESSAGES.INVALID_HEIGHT
			if (errorMsg) {
				looseDetailsErrors[key] = looseDetailsErrors[key]
					? { ...looseDetailsErrors[key], [LOOSE_FORM_FIELDS.HEIGHT]: errorMsg }
					: { [LOOSE_FORM_FIELDS.HEIGHT]: errorMsg }
			}
			setError({ ...error, [FORM_FIELDS.LOOSE_ITEMS]: looseDetailsErrors })
		}
		if (type == 'length') {
			const errorMsg =
				looseDetails[key].length && isNum(looseDetails[key].length)
					? null
					: MESSAGES.INVALID_LENGTH
			if (errorMsg) {
				looseDetailsErrors[key] = looseDetailsErrors[key]
					? { ...looseDetailsErrors[key], [LOOSE_FORM_FIELDS.LENGTH]: errorMsg }
					: { [LOOSE_FORM_FIELDS.LENGTH]: errorMsg }
			}
			setError({ ...error, [FORM_FIELDS.LOOSE_ITEMS]: looseDetailsErrors })
		}
	}
	//============== for bulk upload ===============//
	const isEmpty = looseDetails?.map((item) => {
		if (
			item.pieces === '' &&
			item.length === '' &&
			item.height === '' &&
			item.stackable === true &&
			item.turnable === true &&
			item.weight === '' &&
			item.weightType === 'PER_ITEM' &&
			item.width === ''
		) {
			return true
		} else return false
	})

	const checkIsEmpty = () => {
		let isLooseEmpty = true
		looseDetails?.filter((item) => {
			if (
				item.pieces !== '' ||
				item.length !== '' ||
				item.height !== '' ||
				item.weight != '' ||
				item.width != '' ||
				item.weightType !== 'PER_ITEM'
			) {
				isLooseEmpty = false
			}
		})
		return isLooseEmpty;
	}

	const onReadExcel = (val, weightUnit, dimensionUnit) => {

		//============== for bulk dimension & weight unit ===============//
		if (dimensionUnit === 'cm') {
			setDimensionUnit('C')
		} else if (dimensionUnit === 'inch') {
			setDimensionUnit('I')
		} else return

		if (weightUnit === 'kg') {
			setWeightUnit('K')
		} else if (weightUnit === 'lb') {
			setWeightUnit('L')
		} else if (weightUnit === 't') {
			setWeightUnit('T')
		} else return
		//=================================================//
		let tempLooseDetails = [...looseDetails]
		if (checkIsEmpty()) {
			tempLooseDetails = val
			setLooseDetails(val)
		} else {
			tempLooseDetails = tempLooseDetails.concat(val)
			setLooseDetails(tempLooseDetails)
		}
		let looseDetailsErrors = validateLooseDetails(tempLooseDetails)
		const hasError = looseDetailsErrors.some((item) => (item ? true : false))
		error[FORM_FIELDS.LOOSE_ITEMS] = hasError ? looseDetailsErrors : null
	}
	//==============================================//

	const toggleAllStackable = useCallback(
		(event) => {
			setLooseDetails(
				looseDetails.map((item) => ({ ...item, stackable: !isAllStackable }))
			)
			setDisableButton && setDisableButton(false)

		},
		[looseDetails, setLooseDetails, isAllStackable]
	)

	const toggleAllTiltable = useCallback(
		(event) => {
			setLooseDetails(
				looseDetails.map((item) => ({ ...item, turnable: !isAllTiltable }))
			)
			setDisableButton && setDisableButton(false)

		},
		[looseDetails, setLooseDetails, isAllTiltable]
	)

	useEffect(() => {
		var isStackable = looseDetails.every((stack) => stack.stackable)
		var isTiltable = looseDetails.every((tilt) => tilt.turnable)
		setAllStackable(isStackable)
		setAllTiltable(isTiltable)
	}, [looseDetails, setAllStackable, setAllTiltable])

	/*=================== OPERATIONAL WEIGHT=========================*/
	const handleOperationalWeight = () => {
		setShowOpweight(true)
	}

	const handleRemoveOptWght = () => {
		setShowOpweight(false);
		setAdjustedWeight(null);
		if (error && error[FORM_FIELDS.OPERATIONAL_WEIGHT]) {
			const tempError = { ...error }
			tempError[FORM_FIELDS.OPERATIONAL_WEIGHT] = null
			setError(tempError)
		}
	}

	useEffect(() => {
		if (Number(adjustedWeight) && !showOpWeight) {
			setShowOpweight(true);
		}
	}, [adjustedWeight])




	return (
		<>
			<div className={`cargo-ttlopwght-row ${isRTL ? 'rtl' : ''} ${i18n.language === 'de' ? 'mb-3' : ''}`}>
				<div className={`form-group input-with-dropdown drpdwn-width-limit`}>
					<CommonInput
						type='text'
						label={t('COMMON.ENTER_TOTAL_WEIGHT')}
						className=''
						value={totalWeight && totalWeight !== 0 ? totalWeight : ""}
						onKeyDown={(evt) => allowNumberOnly(evt)}
						onChange={(e) => {
							if (
								e.target.value.length <= 9 &&
								(!e.target.value.split('.')[1] ||
									!e.target.value.split('.')[1].length ||
									e.target.value.split('.')[1].length < 2) &&
								e.target.value.split('.').length <= 2
							) {
								const value = e.target.value.replace(/[^0-9.]/g, '')
								setDisableButton && setDisableButton(false)
								setTotalWeight(value)
								draftCallback()
							}
						}}
						onFocus={(e) => {
							totalWeightOnFocus.current = totalWeight;
							clearError(FORM_FIELDS.TOTAL_WEIGHT);
						}}
						onBlur={(e) => {
							if (Number(totalWeight) !== Number(totalWeightOnFocus.current)) {
								onTotalWeightChange && onTotalWeightChange();
							}
							if (!Number(totalWeight)) {
								setTotalWeight(null);
							}
							handleSummaryChange(looseDetails);
							const totalWeightError = validateTotalWeight(totalWeight, calculatedTotalWeight);
							setError((prevError) => ({
								...prevError,
								[FORM_FIELDS.TOTAL_WEIGHT]: totalWeightError,
							}));
						}}
						error={error && error[FORM_FIELDS.TOTAL_WEIGHT]
							? t(error[FORM_FIELDS.TOTAL_WEIGHT], { ns: 'errors' })
							: ''}

					/>
					<CommonDropDown
						value={weightUnit}
						id={'ttl-wght-unt-dropdown'}
						options={WEIGHT_UNIT_SELECT_ITEMS}
						onChange={(e) => {
							setDisableButton && setDisableButton(false)
							setWeightUnit(e.target.value)
							draftCallback(true)
						}}
						error={error && error[FORM_FIELDS.TOTAL_WEIGHT]}
						isNoLabel
					/>
				</div>


				{!showOpWeight &&
					!isHideReprocessComponents &&
					!adjustedWeight &&
					!isMultipleBookingEdit ? (

					<div className={`form-group opr-wght-section ${showOpWeight ? "d-none" : ''}`}>
						<img className='opwght-plus' src={plusIcon} alt='plus' title='opwght-plus' />
						<Button
							className="p-button-link c p-0 align-items-end"
							label={t("BOOKING.ADD_OPERATIONAL_WEIGHT")}
							type="button"
							onClick={(e) => handleOperationalWeight(e)}
						/>
					</div>
				) : <></>}

				{(showOpWeight) ? (
					<div className="form-group opweight-session">
						<div className={`input-with-dropdown `}>
							<CommonInput
								type="text"
								label={t("BOOKING.OPERATIONAL_WEIGHT")}
								value={adjustedWeight}
								disabled={isAdjustedWeightDisabled}
								onKeyDown={(evt) => allowNumberOnly(evt)}
								onChange={(e) => {
									if (
										e.target.value.length <= 9 &&
										(!e.target.value.split(".")[1] ||
											!e.target.value.split(".")[1].length ||
											e.target.value.split(".")[1].length < 2) &&
										e.target.value.split(".").length <= 2
									) {
										const value = e.target.value.replace(/[^0-9.]/g, "");
										setAdjustedWeight(value);
										draftCallback();
									}
								}}
								onFocus={(e) =>
									clearError(FORM_FIELDS.OPERATIONAL_WEIGHT)
								}
								onBlur={(e) => {
									if (!Number(adjustedWeight)) {
										setAdjustedWeight(null);
									}
									//handleSummaryChange(looseDetails)
									handleOpWeightErr(FORM_FIELDS.OPERATIONAL_WEIGHT);
								}}
								error={error && error[FORM_FIELDS.OPERATIONAL_WEIGHT]
									? t(error[FORM_FIELDS.OPERATIONAL_WEIGHT], {
										ns: "errors",
									})
									: ""}
							/>
							<CommonDropDown
								value={weightUnit}
								disabled={isAdjustedWeightDisabled}
								id={'opweight-drpdwn'}
								options={WEIGHT_UNIT_SELECT_ITEMS}
								onChange={(e) => {
									setDisableButton && setDisableButton(false);
									setWeightUnit(e.target.value);
									draftCallback(true);
								}}
								error={error && error[FORM_FIELDS.OPERATIONAL_WEIGHT]}
								isNoLabel
							/>
						</div>
						<label className="ops-weight">
							<span className="description-text">{t("COMMON.OP_WEIGHT_HINT")}</span>
							{!isAdjustedWeightDisabled && (
								<span className="remove-text ml-1" onClick={handleRemoveOptWght}>{t("COMMON.REMOVE_OP_WEIGHT")}</span>
							)}
						</label>
					</div>
				) : <></>}
			</div>
			<div className="cargo-pieceschkbox-row">
				<label className='sub-head-label mb-0'>{t("COMMON.ALL_PCS_ARE")}</label>
				<div className=" chkbox-session">
					<div className="l-checkbox">
						<input
							id={`stackable`}
							type="checkbox"
							checked={isAllStackable}
							onChange={toggleAllStackable}
						/>
						<label className="mb-0" htmlFor={`stackable`}>
							{t("COMMON.STACKABLE")}
						</label>
					</div>
					<div className="l-checkbox">
						<input
							id={`turnable`}
							type="checkbox"
							checked={isAllTiltable}
							onChange={toggleAllTiltable}
						/>
						<label className="mb-0" htmlFor={`turnable`}>
							{t("COMMON.TILTABLE")}
						</label>
					</div>
				</div>
			</div>
			{looseDetails &&
				looseDetails.length &&
				looseDetails.map((item, key) => {
					const piecesError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.PIECES]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.PIECES]
							: null;
					const lengthError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.LENGTH]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.LENGTH]
							: null;
					const widthError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.WIDTH]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.WIDTH]
							: null;
					const heightError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.HEIGHT]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.HEIGHT]
							: null;
					const weightError =
						error &&
							error[FORM_FIELDS.LOOSE_ITEMS] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key] &&
							error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.WEIGHT]
							? error[FORM_FIELDS.LOOSE_ITEMS][key][LOOSE_FORM_FIELDS.WEIGHT]
							: null;
					return (
						<div
							className={`cargo-dimensions-row ${key > 0 ? 'neg-margin' : ''} ${looseDetails.length - 1 === key ? "last-item" : ""
								}`}
							key={key}
						>
							<div className="form-row-dimensions mb-0">
								{/* Pieces */}
								<div
									className={`form-group ${piecesError ? "red-border" : ""
										}`}
								>
									<CommonInput
										type="text"
										label={t("COMMON.PCS")}
										value={item.pieces === 0 ? "" : item.pieces}
										onChange={(e) => {
											const value = e.target.value.replace(/[^\d]/, "");
											setDisableButton && setDisableButton(false);
											handleItemChange("pieces", value, key);
										}}
										onFocus={() => {
											setFocusedIndex(key);
											clearItemError(LOOSE_FORM_FIELDS.PIECES, key);
										}}
										onBlur={() => {
											setFocusedIndex(null);
											if (!Number(item.pieces))
												handleItemChange("pieces", "", key);
											validateLineItemOnBlur("pieces", key);
											handleWeightInput(looseDetails);
										}}
										error={
											piecesError ? t(piecesError, { ns: "errors" }) : ""
										}
										focused={focusedIndex === 0}
									/>
								</div>

								{/* Length */}
								<div
									className={`form-group  ${lengthError ? "red-border" : ""
										}`}
								>
									<CommonInput
										type="text"
										label={t("COMMON.LN")}
										value={item.length === 0 ? "" : item.length}
										onChange={(e) => {
											const value = e.target.value.replace(/[^\d]/g, "");
											setDisableButton && setDisableButton(false);
											handleItemChange("length", value, key);
										}}
										onFocus={() => {
											setFocusedIndex(key);
											clearItemError(LOOSE_FORM_FIELDS.LENGTH, key);
										}}
										onBlur={(e) => {
											setFocusedIndex(null);
											if (!Number(item.length))
												handleItemChange("length", "", key);
											validateLineItemOnBlur("length", key);
											handleSummaryChange(looseDetails);
										}}
										error={
											lengthError ? t(lengthError, { ns: "errors" }) : ""
										}
										focused={focusedIndex === 0}
									/>

								</div>

								{/* Width */}
								<div
									className={`form-group ${widthError ? "red-border" : ""
										}`}
								>

									<CommonInput
										type="text"
										label={t("COMMON.WD")}
										value={item.width === 0 ? "" : item.width}
										onChange={(e) => {
											const value = e.target.value.replace(/[^\d]/g, "");
											setDisableButton && setDisableButton(false);
											handleItemChange("width", value, key);
										}}
										onFocus={() => {
											setFocusedIndex(key);
											clearItemError(LOOSE_FORM_FIELDS.WIDTH, key);
										}}
										onBlur={(e) => {
											setFocusedIndex(null);
											if (!Number(item.width))
												handleItemChange("width", "", key);
											validateLineItemOnBlur("width", key);
											handleSummaryChange(looseDetails);
										}}
										error={widthError ? t(widthError, { ns: "errors" }) : ""}
										focused={focusedIndex === 0}

									/>

								</div>

								{/* Height */}
								<div
									className={`form-group ${heightError ? "red-border" : ""
										}`}
								>

									<CommonInput
										type="text"
										label={t("COMMON.HT")}
										id={`height-${key}`}
										value={item.height === 0 ? "" : item.height}
										onChange={(e) => {
											const value = e.target.value.replace(/[^\d]/g, "");
											setDisableButton && setDisableButton(false);
											handleItemChange("height", value, key);
										}}
										onFocus={() => {
											setFocusedIndex(key);
											clearItemError(LOOSE_FORM_FIELDS.HEIGHT, key);
										}}
										onBlur={(e) => {
											setFocusedIndex(null);
											if (!Number(item.height))
												handleItemChange("height", "", key);
											validateLineItemOnBlur("height", key);
											handleSummaryChange(looseDetails);
										}}
										error={heightError ? t(heightError, { ns: "errors" }) : ""}
										focused={focusedIndex === 0}
									/>

								</div>

								{/* Dimension Unit Dropdown*/}
								<CommonDropDown
									label={t("COMMON.UNIT_TYPE")}
									className={'loose-dimension-unit-dropdown'}
									value={dimensionUnit}
									options={DIMENSION_UNIT_SELECT_ITEMS}
									onChange={(e) => {
										setDimensionUnit(e.target.value);
										setDisableButton && setDisableButton(false);
										handleItemChange(
											"dimensionUnit",
											e.target.value,
											key
										);
										draftCallback(true);
									}}
									disabled={key ? true : false}
									dataKey={item.dimensionUnit}
								/>
							</div>
							<div className="form-row-weight mb-0">
								<div className='wght-left-section'>
									{/* Weight Field with Dropdown */}
									{!isHideReprocessComponents && (
										<div
											className={`form-group input-with-dropdown`}
										>
											<CommonInput
												type="text"
												label={t("COMMON.WT_OPT")}
												className=''
												value={item.weight === 0 ? "" : item.weight}
												onChange={(e) => {
													const value = e.target.value.replace(
														/[^0-9.]/g,
														""
													);
													if (
														value.length <= 9 &&
														(!value.split(".")[1] ||
															value.split(".")[1].length < 2) &&
														value.split(".").length <= 2
													) {
														setDisableButton && setDisableButton(false);
														handleItemChange("weight", value, key);
													}
													handleSummaryChange(looseDetails);
												}}
												onFocus={() => {
													setFocusedIndex(key);
													clearItemError(LOOSE_FORM_FIELDS.WEIGHT, key);
												}}
												onBlur={(e) => {
													setFocusedIndex(null);
													handleWeightInput(looseDetails);
													if (
														(!e.target.value ||
															!e.target.value.length) &&
														!looseDetails.some((d) => d.weight)
													) {
														handleLineItemWeightRemoval();
													}
												}}
												error={weightError
													? t(weightError, { ns: "errors" })
													: ""}
												focused={focusedIndex === 0}
											/>

											<CommonDropDown
												value={weightUnit}
												options={WEIGHT_UNIT_SELECT_ITEMS}
												onChange={(e) => {
													setDisableButton && setDisableButton(false);
													setWeightUnit(e.target.value);
													handleItemChange(
														"weightUnit",
														e.target.value,
														key
													);
												}}
												disabled={key ? true : false}
												error={weightError}
												isNoLabel
											/>
										</div>

									)}

									{!isHideReprocessComponents && (
										<div className="form-group weight-type">
											<label className='sub-head-label'>{t("COMMON.WT_TYPE")}</label>
											<RadioToggle
												checkedArray={[item.weightType === DETAILS_APPLY_FOR.PER_ITEM, item.weightType === DETAILS_APPLY_FOR.TOTAL]}
												valueArray={[DETAILS_APPLY_FOR.PER_ITEM, DETAILS_APPLY_FOR.TOTAL]}
												labelArray={["COMMON.PER_ITEM", "COMMON.TOTAL"]}
												className={`weight-type-toggle-${key}`}
												onChangeArray={[(e) => {
													setDisableButton && setDisableButton(false);
													handleItemChange(
														"weightType",
														e.target.value,
														key
													);
												},
												(e) => {
													setDisableButton && setDisableButton(false);
													handleItemChange(
														"weightType",
														e.target.value,
														key
													);
													handleWeightInput(looseDetails);
													handleSummaryChange(looseDetails);
												}]}
											/>
										</div>
									)}
									<div className="form-group packing-type">
										<label className='sub-head-label'>{t("COMMON.PCKG_TYPE")}</label>
										<div className="chkbox-session">
											<div className="l-checkbox">
												<input
													id={`stackable-${key}`}
													type="checkbox"
													disabled={isAllStackable}
													checked={!item.stackable}
													onChange={(e) =>
														handleItemChange(
															"stackable",
															e.target.checked,
															key
														)
													}
												/>
												<label className="mb-0" htmlFor={`stackable-${key}`}>
													{t("COMMON.NON_STACKABLE")}
												</label>
											</div>
											<div className="l-checkbox">
												<input
													id={`turnable-${key}`}
													type="checkbox"
													disabled={isAllTiltable}
													checked={!item.turnable}
													onChange={(e) =>
														handleItemChange(
															"turnable",
															e.target.checked,
															key
														)
													}
												/>
												<label className="mb-0" htmlFor={`turnable-${key}`}>
													{t("COMMON.NON_TILTABLE")}
												</label>
											</div>
										</div>
									</div>
								</div>
								<div className='wght-right-section'>
									{looseDetails.length > 1 && (
										<div className='delete-section ml-auto mt-auto' onClick={(e) => handleRemoveItem(key)}>
											<img src={deleteIcon} alt="Trash" title="Trash" id='Trash-icon' />
											<span>{t("COMMON.REMOVE")}</span>
										</div>
									)}
								</div>
							</div>
						</div>
					);
				})}
			{!isHideReprocessComponents && !isMultipleBookingEdit && (
				<>
					{showFileUpload && <FileUpload onRead={onReadExcel} closeButtonClick={() => setShowFileUpload(false)} needNegMargin={true} />}
					<div className="cargo-addupload-row neg-margin  mb-0">
						<div className="add-more-btn" onClick={(e) => handleClickAdd(e)}>
							<img className='add-more-plus' src={plusIcon} alt='plus' title='add-more-plus' />
							<a className="add-more-link">
								<span>{`${t('COMMON.ADD_ANOTHER')}`}</span>
							</a>
						</div>
						<label className='or-label'>{t("COMMON.OR")}</label>
						<div className="add-more-btn" onClick={() => setShowFileUpload(true)}>
							<img className='upload-icon' src={uploadIcon} alt='upload' title='upload-icon' />
							<a className="add-more-link">
								<span>{`${t('PERMANENT_BOOKING.MASS_UPLOAD')}`}</span>
							</a>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default LooseItemForm;


